import React, { Component } from 'react';
import { isEqual } from 'lodash';

import { EventsTableColumns } from '../../events/eventsTable';
import { MonitoringSummary } from '../summary/MonitoringSummary';
import { MonitoringTableContainer } from '../table/MonitoringTableContainer';

import { PageTitle } from 'components/pages/pageTitle';

const MonitoringPageTableColumns = [
  EventsTableColumns.ClientName,
  EventsTableColumns.EventName,
  EventsTableColumns.EventType,
  EventsTableColumns.EventStart,
  EventsTableColumns.Status,
  EventsTableColumns.NoOfParticipants,
  EventsTableColumns.NoOfParticipantsWithUploadedData,
  EventsTableColumns.NoOfParticipantsWithUploadedDataInSubmittedState,
  EventsTableColumns.NoOfParticipantsWithUploadedDataInAcceptedState,
  EventsTableColumns.NoOfParticipantsInRejectedState,
  EventsTableColumns.ViewButton,
];

const MonitoringStatisticsRows = {
  [EventsTableColumns.NoOfParticipants]: 'Total participants',
  [EventsTableColumns.NoOfParticipantsWithUploadedData]: 'Total uploaded',
  [EventsTableColumns.NoOfParticipantsWithUploadedDataInSubmittedState]: 'Total submitted',
  [EventsTableColumns.NoOfParticipantsWithUploadedDataInAcceptedState]: 'Total accepted',
  [EventsTableColumns.NoOfParticipantsInRejectedState]: 'Total rejected',
};

const initialState = {
  [EventsTableColumns.NoOfParticipants]: 0,
  [EventsTableColumns.NoOfParticipantsWithUploadedData]: 0,
  [EventsTableColumns.NoOfParticipantsWithUploadedDataInSubmittedState]: 0,
  [EventsTableColumns.NoOfParticipantsWithUploadedDataInAcceptedState]: 0,
  [EventsTableColumns.NoOfParticipantsInRejectedState]: 0,
};

const MonitoringStatisticsKeys = Object.keys(MonitoringStatisticsRows);

const createObjectFromKeys = (keys: string[], initialValue: unknown = undefined) =>
  keys.reduce((acc, key) => ({ ...acc, [key]: initialValue }), {});

const calculate = (rows: any[], keys: any[]) =>
  rows.reduce(
    (stats, row) =>
      keys.reduce(
        (acc, key) => ({
          ...acc,
          [key]: stats[key] + (row[key] || 0),
        }),
        {},
      ),
    createObjectFromKeys(keys, 0),
  );

type MonitoringVGState = {
  visibleStats: { [key in keyof typeof MonitoringStatisticsRows]: number };
  allStats: { [key in keyof typeof MonitoringStatisticsRows]: number };
};

export class MonitoringVG extends Component<any, MonitoringVGState> {
  constructor(props: any) {
    super(props);

    this.state = {
      visibleStats: initialState,
      allStats: initialState,
    };
  }

  handleStatisticsChange = (filteredRows: any[] | undefined, allRows: any[] | undefined) => {
    if (!filteredRows || !allRows) {
      return;
    }

    const visibleStats = calculate(filteredRows, MonitoringStatisticsKeys);
    const allStats = calculate(allRows, MonitoringStatisticsKeys);

    this.setState(prevState => ({
      visibleStats,
      allStats: isEqual(prevState.allStats, initialState) ? allStats : prevState.allStats,
    }));
  };

  render() {
    const { fetchStatistics, fetchEvents } = this.props;
    const { visibleStats, allStats } = this.state;

    return (
      <>
        <PageTitle displayTitle="Virtual Graduation Statistics" />
        <>
          <MonitoringSummary
            data={visibleStats}
            title="Statistics for selected events"
            labels={MonitoringStatisticsRows}
          />
          <MonitoringSummary data={allStats} title="Statistics for all time events" labels={MonitoringStatisticsRows} />
          <MonitoringTableContainer
            columns={MonitoringPageTableColumns}
            onFilterChange={this.handleStatisticsChange}
            getStatistics={fetchStatistics}
            fetchEvents={fetchEvents}
          />
        </>
      </>
    );
  }
}
